import React, { useState } from "react";
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

import UploadGalleryStore from "./uploadGalleryStore";
import UploadGallery from "./UploadGallery";
import ImageEditor from "./ImageEditor";


function UploadGalleryModal(props) {

  const [uploadGalleryStore, setUploadGalleryStore] = useState(
    new UploadGalleryStore(props.galleryApi)
  );

  const [isEditingImage, setIsEditingImage] = useState(false); // Triggers editor

  const [editingErrors, setEditingErrors] = useState([]); // Hold errors found while editing image

  const resetModal = () => {
    uploadGalleryStore.setDraftImage({})

    uploadGalleryStore.setDraftImageErrors({
      smallResolution: false,
      largeResolution: false,
      wrongAspectRatio: false,
      largeFileSize: false,
    })

    setEditingErrors([]);
    setIsEditingImage(false);
  }

  return (
    <Modal
      isOpen={true}
      toggle={() => props.modalToggle(false)}
      className="modal-lg"
    >
      <ModalHeader toggle={() => props.modalToggle(false)}>
        {isEditingImage
          ? "Confirm Image Correction "
          : props.title
        }
      </ModalHeader>
      <ModalBody>
        {isEditingImage ? 
          <div>
            {
            editingErrors.length === 0 ? 
              <ImageEditor 
                uploadGalleryStore={uploadGalleryStore}  
                minImageWidthPixels={props.minImageWidthPixels}
                minImageHeightPixels={props.minImageHeightPixels}
                maxImageWidthPixels={props.maxImageWidthPixels}
                maxImageHeightPixels={props.maxImageHeightPixels}
                imageAspectRatio={props.imageAspectRatio}
                aspectRatioPrettyReadable={props.aspectRatioPrettyReadable}
                editingErrors={editingErrors}
                setEditingErrors={setEditingErrors}
              />
            :
              <div className="alert alert-danger">
                {editingErrors.map(error => <p>{error}</p>)}
              </div>
            }
          </div>
         : (
          <UploadGallery
            uploadGalleryStore={uploadGalleryStore}
            minImageWidthPixels={props.minImageWidthPixels}
            minImageHeightPixels={props.minImageHeightPixels}
            maxImageWidthPixels={props.maxImageWidthPixels}
            maxImageHeightPixels={props.maxImageHeightPixels}
            imageAspectRatio={props.imageAspectRatio}
            aspectRatioPrettyReadable={props.aspectRatioPrettyReadable}
            imageSelectedCallback={props.imageSelectedCallback}
            setIsEditingImage={setIsEditingImage}
            maxFileSizeBytes={props.maxFileSizeBytes}
            fileTypes={props.fileTypes}
          />
        )}
      </ModalBody>
      <ModalFooter>
        <button
          className="btn btn-outline-secondary"
          onClick={() => isEditingImage ? resetModal() : props.modalToggle(false)}
        >
          Cancel
        </button>
        {
          isEditingImage && editingErrors.length === 0 &&
          <button 
            className="btn btn-secondary" 
            onClick={() => uploadGalleryStore.saveChatterUpload(uploadGalleryStore.editedImageFile)}
          >
            Add Image
          </button>
        }
        {
          isEditingImage && editingErrors.length !== 0 &&
          <button 
            className="btn btn-secondary" 
            onClick={resetModal}
          >
            Try Again
          </button>
        }
      </ModalFooter>
    </Modal>
  );
}

UploadGalleryModal.propTypes = {
  title: PropTypes.string.isRequired,
  modalToggle: PropTypes.func.isRequired,
  imageSelectedCallback: PropTypes.func.isRequired,
  minImageWidthPixels: PropTypes.number,
  minImageHeightPixels: PropTypes.number,
  maxImageWidthPixels: PropTypes.number, 
  maxImageHeightPixels: PropTypes.number, 
  imageAspectRatio: PropTypes.number,
  aspectRatioPrettyReadable: PropTypes.string,
  maxFileSizeBytes: PropTypes.number,
  fileTypes: PropTypes.string,
  galleryApi: PropTypes.object, // If non provided, then defaults to social gallery api
}

export default UploadGalleryModal;
